import { Trans } from 'react-i18next';

import { AppointmentCancellationDetails } from '@dreryk/egabinet-appointment-frontend-api';

import { inTranslationMap, useTranslate } from '@dreryk/react-common';

import { calendarTranslationKeys } from '../../../../../../translations';

const t = calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab;

export const useGetCancellationBy = (cancellationDetails: AppointmentCancellationDetails): JSX.Element => {
   const translate = useTranslate();
   const { cancelledByPractitioner, cancelledBySourceLabel } = cancellationDetails;

   if (cancelledByPractitioner) {
      const practitionerFullname = `${cancelledByPractitioner.firstName} ${cancelledByPractitioner.lastName}`;

      return <Trans i18nKey={t.cancellationBy} values={{ cancellationBy: practitionerFullname }} />;
   }

   if (cancelledBySourceLabel && inTranslationMap(t.cancellationByExternalSourceLabelMap, cancelledBySourceLabel)) {
      const cancellationBy = t.cancellationByExternalSourceLabelMap[cancelledBySourceLabel];

      return <Trans i18nKey={t.cancellationBy} values={{ cancellationBy: translate(cancellationBy) }} />;
   }

   return (
      <Trans i18nKey={t.cancellationBy} values={{ cancellationBy: translate(t.cancellationByUnknownExternalSource) }} />
   );
};
